import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Row, Col} from 'antd';
import ActivityStore from 'stores/activity';
import clientStore from 'stores/client';
import ClientDetails from '../components/ClientDetails';
import ClientForm from 'modules/clients/components/New/Form'
import ActivityList from 'submodules/clients/components/ActivityList';
import AppLayout from "modules/clients/containers/Single/components/Layout";
import { EditOutlined } from "@ant-design/icons";

const Overview: FC = observer(() => {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const client: any = clientStore.selected;

  useEffect(() =>  {
    return () => ActivityStore.clearValues()
  }, [client?.id])

  const editClient = () => setIsEdit(true);

  const cancelEdit = () => setIsEdit(false);

  return (
    <AppLayout>
      <div className="tab">
        <Row justify='space-between' align='top'>
          <Col span={8} className='portlet'>
            <Row justify='space-between' className='portlet-head'>
              <h5>{t('clients.clientDetail')}</h5>
              <EditOutlined className='cursor-pointer' onClick={editClient} />
            </Row>

            <div className='portlet-body'>
              {isEdit ? <ClientForm client={client} onCancelButton={cancelEdit} /> : <ClientDetails client={client} />}
            </div>
          </Col>

          <Col span={15}>
            <ActivityList client={client} />
          </Col>
        </Row>
      </div>
    </AppLayout>
  );
})

export default Overview;
